import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { cleanedParams } from "../../plugins/utils";
import { SearchParams, SearchResponse } from "./data";
import { apiGetSessionList } from "./service";

export const useGetSessions = (params: SearchParams, options: any) => {
  const queryKeyArr = [
    queryKey.SESSION_LIST,
    ...Object.values(cleanedParams(params)),
  ];

  return useQuery<SearchResponse[]>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetSessionList(params).then((res: ApiResponse<SearchResponse[]>) => {
        return res.data.data.map((resp: SearchResponse) => {
          return {
            ...resp,
            order_price: resp.total_price,
            coach_designated: params.coach_designated,
            coach_account_id:
              params.coach_account_id === "null"
                ? null
                : params.coach_account_id,
          };
        });
      }),
    ...options,
  });
};
